export let regExp = {
    name:/^[\u4e00-\u9fa5]{2,6}$/,
    phone:/^[1][3,4,5,6,7,8][0-9]{9}$/,
    wx:/^[a-zA-Z\d_]{5,}$/
}